<div class="file-edit">
  <div class="buttons">
    <button mat-raised-button color="primary" (click)="fileInput.click()">Choose File</button>

    @if (fileSelected) {
      <button    mat-raised-button (click)="doCrop()">
        Select
      </button>
    }
  </div>


  <image-cropper
    [imageChangedEvent]="imageChangedEvent"
    [maintainAspectRatio]="true"
    [aspectRatio]="4 / 4"
    format="png"
    [resizeToWidth]="128"
    [resizeToHeight]="128"
    [autoCrop]="false"
    [roundCropper]="true"
    (imageCropped)="imageCropped($event)"
    (imageLoaded)="imageLoaded($event)"
    (cropperReady)="cropperReady()"
    (loadImageFailed)="loadImageFailed()"
    #cropper
  ></image-cropper>
  <input type="file" #fileInput (change)="fileChangeEvent($event)" />

</div>
